<template>
    <cic-popup :title="title" class="no-padding" @blur="$emit('blur')">
        <table id="licencesummaryusers_table" class="cic-table">
            <thead>
                <tr>
                    <th>{{ $t('User') }}</th>
                </tr>
            </thead>
            <LoadingTable v-if="$store.isLoading('licencesummary/users')" :columns="1" />
            <tbody v-else>
                <tr v-for="user in users">
                    <td>
                        {{ formatUsername(user) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </cic-popup>
</template>

<script>
    import { LoadingTable } from '@/components/container';
    import CicPopup from '@/components/CicPopup';
    import { formatUsername } from '../LicenceUtils';

    export default {
        name: 'LicenceSummaryUsers',
        components: {
            CicPopup,
            LoadingTable,
        },
        props: {
            title: {
                type: String,
                required: true,
            },
            users: {
                type: Array,
                required: true,
            },
        },
        emits: ['blur'],
        methods: {
            formatUsername,
        },
    };
</script>
